import { render, staticRenderFns } from "./BomChange.vue?vue&type=template&id=49de75de"
import script from "./BomChange.vue?vue&type=script&lang=js"
export * from "./BomChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports